import React from 'react'

import { Note as NT } from '@constants'
import { Icon, Tooltip, Text } from '@components/UI'

const Alignment = ({ active, onClick, dark, tooltip = {} }) => {
  return (
    <div
      className={`control-container ${active ? 'active' : ''} ${
        dark ? 'dark' : ''
      }`}
    >
      <button>
        {active === NT.TOOLS.ALIGN.LEFT ? (
          <Icon name='text align left' />
        ) : active === NT.TOOLS.ALIGN.CENTER ? (
          <Icon name='text align center' className='active' />
        ) : active === NT.TOOLS.ALIGN.RIGHT ? (
          <Icon name='text align right' className='active' />
        ) : active === NT.TOOLS.ALIGN.JUSTIFY ? (
          <Icon name='text align justify' className='active' />
        ) : null}
      </button>

      <Tooltip
        content={
          <div className='tooltip-content'>
            <Text
              className='text-c semibold'
              style={{ lineHeight: 1, opacity: 0.5 }}
            >
              Alignment
            </Text>
            <div style={{ display: 'flex', marginTop: 8 }}>
              <div
                className={`control-container ${dark ? 'dark' : ''} ${
                  active === NT.TOOLS.ALIGN.LEFT ? 'active' : ''
                }`}
              >
                <button onClick={() => onClick(false)}>
                  <Icon name='text align left' />
                </button>
              </div>
              <div
                className={`control-container ${dark ? 'dark' : ''} ${
                  active === NT.TOOLS.ALIGN.CENTER ? 'active' : ''
                }`}
              >
                <button onClick={() => onClick('center')}>
                  <Icon name='text align center' />
                </button>
              </div>
              <div
                className={`control-container ${dark ? 'dark' : ''} ${
                  active === NT.TOOLS.ALIGN.RIGHT ? 'active' : ''
                }`}
              >
                <button onClick={() => onClick('right')}>
                  <Icon name='text align right' />
                </button>
              </div>
              <div
                className={`control-container ${dark ? 'dark' : ''} ${
                  active === NT.TOOLS.ALIGN.JUSTIFY ? 'active' : ''
                }`}
              >
                <button onClick={() => onClick('justify')}>
                  <Icon name='text align justify' />
                </button>
              </div>
            </div>
          </div>
        }
        group={tooltip.top ? 'c2' : 'c7'}
        className='theme color-f background-a border'
      />
      <Icon name='arrow down' />
    </div>
  )
}

export default Alignment
